<script setup>
import { ref } from 'vue';
import ModalWrapper from './ModalWrapper.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: 'Eliminar' },
  message: { type: String, default: '¿Querés eliminar este elemento?' },
});
const emit = defineEmits(['confirm', 'close']);

const confirmed = ref(false);
const loading = ref(false);

function handleFirst() { confirmed.value = true; }
async function handleConfirm() {
  loading.value = true;
  emit('confirm');
}
function handleClose() {
  confirmed.value = false;
  loading.value = false;
  emit('close');
}
</script>

<template>
  <ModalWrapper :show="show" :title="title" @close="handleClose">
    <template v-if="!confirmed">
      <p class="aj-delete-msg">{{ message }}</p>
      <div class="aj-delete-actions">
        <button class="aj-btn aj-btn-ghost" @click="handleClose">Cancelar</button>
        <button class="aj-btn aj-btn-danger" @click="handleFirst">Eliminar</button>
      </div>
    </template>
    <template v-else>
      <p class="aj-delete-msg">¿Estás seguro? Esta acción no se puede deshacer.</p>
      <div class="aj-delete-actions">
        <button class="aj-btn aj-btn-ghost" @click="handleClose">Cancelar</button>
        <button class="aj-btn aj-btn-danger" :disabled="loading" @click="handleConfirm">
          {{ loading ? 'Eliminando...' : 'Sí, eliminar' }}
        </button>
      </div>
    </template>
  </ModalWrapper>
</template>

<style scoped>
.aj-delete-msg { font-size: 14px; color: rgb(var(--slate-11, 96 100 108)); margin-bottom: 16px; }
.aj-delete-actions { display: flex; gap: 8px; justify-content: flex-end; }
.aj-btn { padding: 8px 16px; border-radius: 10px; font-size: 13px; font-weight: 500; cursor: pointer; border: none; min-height: 40px; }
.aj-btn-ghost { background: rgb(var(--slate-3, 240 240 243)); color: rgb(var(--slate-12, 28 32 36)); }
.aj-btn-danger { background: rgb(var(--ruby-9, 229 70 102)); color: #fff; }
.aj-btn-danger:disabled { opacity: 0.6; }
</style>
